import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const contactsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/contacts",
  component: lazyRouteComponent(() => import("./contacts.page.js"), "ContactsPage"),
});
